import {CountUp} from "countup.js";
import Calculator from "./Calculator";

const CalculatorResults={
    show(){

        setTimeout(()=>{
            this.count(Calculator.outcome.find('.save3a'));
        }, 300)

        setTimeout(()=>{
            this.count(Calculator.outcome.find('.save3b'));
        }, 500)

        setTimeout(()=>{
            this.count(Calculator.outcome.find('.save5a'));
        }, 700)

        setTimeout(()=>{
            this.count(Calculator.outcome.find('.save5b'));
        }, 900)

    },

    count(target) {
        let start = parseInt(target.attr('start'));
        let end = parseInt(target.attr('end'));
        const countUp = new CountUp(target[0], end, {startVal: start, separator: ' ', duration: 1});
        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }
    },
}

export default CalculatorResults;